import {API_DOMAIN} from '../constants';

export const API_BASE_URL = `${API_DOMAIN}/api`;

// SSE
export const SSE_STREAM_URL = '/v1/broker-portal/events/stream';

export const SSO_ENDPOINT = '/v1/broker-portal/sso';
export const CONSENT_ENDPOINT = '/v1/broker-portal/consent';

export const CLIENT_ANALYSES_ENDPOINT = '/v1/broker-portal/client-analyses';

export const TAG_TYPES: Record<string, string> = {
    clientAnalyses: 'clientAnalyses'
};
